const ClientConnectionStatusEnum = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
}

export default Object.freeze(ClientConnectionStatusEnum)
